import React, { useState } from "react";
import Model from "../Model";
import tw from "tailwind-styled-components";

const WebsiteVisibilityProperty = ({
    setIsWebsiteVisibiltyProperty,
    selectedData,
    deleteWebsiteVisibilityLoading,
    deleteWebsiteVisibilityMutate,
    initialVisibility = false,
}) => {
    const [isVisible, setIsVisible] = useState(initialVisibility);

    const handleToggle = () => {
        setIsVisible(!isVisible);
        deleteWebsiteVisibilityMutate({ propId: selectedData?.id, isVisible: isVisible ? 0 : 1 });
    };
    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsWebsiteVisibiltyProperty}
            title="Website Visibility"
        >
            {/* <WarningText>
                Control whether this property appears on your website
            </WarningText> */}

            <SettingCard $active={isVisible}>
                <SettingContent>
                    <SettingHeader>
                        <TitleRow>
                            <SettingTitle>Show Property on Website</SettingTitle>
                            <BadgeGroup>
                                {!isVisible && (
                                    <RecommendedBadge>Recommended</RecommendedBadge>
                                )}
                                {isVisible && (
                                    <StatusBadge $variant="info">Visible</StatusBadge>
                                )}
                            </BadgeGroup>
                        </TitleRow>

                        <SettingDescription>
                            When enabled, this property will be visible to visitors on your public website.
                        </SettingDescription>

                        {isVisible && (
                            <ImpactText className="text-green-600">
                                ↑ Increases property exposure and attracts more potential tenants
                            </ImpactText>
                        )}

                        {!isVisible && (
                            <HelperText>
                                Property will be hidden from the website until you enable visibility.
                            </HelperText>
                        )}
                    </SettingHeader>

                    <ToggleWrapper>
                        <Toggle
                            checked={isVisible}
                            onChange={handleToggle}
                            disabled={deleteWebsiteVisibilityLoading}
                        />
                    </ToggleWrapper>
                </SettingContent>
            </SettingCard>

        </Model>
    );
};

// Toggle Component
const Toggle = ({ checked, onChange, disabled }) => (
    <ToggleLabel disabled={disabled}>
        <ToggleInput
            type="checkbox"
            checked={checked}
            onChange={onChange}
            disabled={disabled}
        />
        <ToggleSlider checked={checked} disabled={disabled}>
            <ToggleThumb checked={checked} />
        </ToggleSlider>
    </ToggleLabel>
);

// Styled Components
const WarningText = tw.p`text-gray-500 text-base mb-4`;

const SettingCard = tw.div`
    relative rounded-2xl border p-4 transition-all duration-200 bg-white mb-6
    ${(p) =>
        p.$active
            ? "border-primary-color shadow-sm ring-1 ring-primary-color/20"
            : "border-gray-200 hover:border-gray-300 hover:shadow-sm"}
`;

const SettingContent = tw.div`
    flex items-center justify-between gap-4
`;

const SettingHeader = tw.div`flex-1`;

const SettingTitle = tw.h3`
    text-sm font-semibold text-gray-800
`;

const SettingDescription = tw.p`
    text-xs text-gray-500 leading-relaxed mt-1
`;

const TitleRow = tw.div`
    flex items-center justify-between gap-2 mb-1
`;

const BadgeGroup = tw.div`
    flex items-center gap-2
`;

const RecommendedBadge = tw.span`
    text-[10px] font-medium px-2 py-0.5 rounded-full bg-blue-100 text-blue-700
`;

const StatusBadge = tw.span`
    text-[10px] font-medium px-2 py-0.5 rounded-full
    ${(p) =>
        p.$variant === "warning"
            ? "bg-yellow-100 text-yellow-700"
            : p.$variant === "info"
                ? "bg-green-100 text-green-700"
                : "bg-gray-100 text-gray-700"}
`;

const ImpactText = tw.p`
    text-xs font-medium mt-2
`;

const HelperText = tw.p`
    text-xs text-gray-400 mt-1
`;

const ToggleWrapper = tw.div`
    flex items-center justify-center
`;

const ToggleLabel = tw.label`
    relative inline-flex items-center
    ${props => props.disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}
`;

const ToggleInput = tw.input`
    sr-only peer
`;

const ToggleSlider = tw.div`
    relative w-12 h-6 rounded-full transition-colors duration-200 ease-in-out
    ${props =>
        props.disabled
            ? 'bg-gray-200 cursor-not-allowed'
            : props.checked
                ? 'bg-primary-color'
                : 'bg-gray-300'
    }
`;

const ToggleThumb = tw.div`
    absolute top-0.5 left-0.5 w-5 h-5 bg-white border border-gray-300 rounded-full shadow-sm
    transition-transform duration-200 ease-in-out
    ${props => props.checked ? 'transform translate-x-6' : ''}
`;


export default WebsiteVisibilityProperty;